import { Pipe, PipeTransform } from '@angular/core';
import { Employee } from 'src/app/shared/models/employee/employee';

@Pipe({
	name: 'filterEmployeeByAllFields'
})
export class FilterEmployeeByAllFieldsPipe implements PipeTransform {
	transform(employees: Employee[], filter: string): Employee[] {
		if (
			!employees ||
			employees === null ||
			!filter ||
			filter === null ||
			filter === ''
		) {
			return employees;
		}

		filter = filter.toLowerCase();

		return employees.filter((employee) => {
			const employeeName = employee?.firstName + ' ' + employee?.lastName;
			return (
				employeeName?.toLowerCase().includes(filter) ||
				employee.email?.toLowerCase().includes(filter) ||
				employee.expertises?.some((exp) =>
				exp.name.toLowerCase().includes(filter)
				)
			);
		});
	}
}
